import { render } from "./dividas.vue?vue&type=template&id=0f969190&scoped=true"
import script from "./dividas.vue?vue&type=script&lang=js"
export * from "./dividas.vue?vue&type=script&lang=js"

import "./dividas.vue?vue&type=style&index=0&id=0f969190&scoped=true&lang=scss"

import exportComponent from "/var/www/amee/iptu-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f969190"]])

export default __exports__